import { render, staticRenderFns } from "./autoRow.vue?vue&type=template&id=88253968&scoped=true"
import script from "./autoRow.vue?vue&type=script&lang=js"
export * from "./autoRow.vue?vue&type=script&lang=js"
import style0 from "./autoRow.vue?vue&type=style&index=0&id=88253968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88253968",
  null
  
)

export default component.exports